const apps = ["halobear"];
const userAgent = navigator.userAgent.toLowerCase();

// 判断是否是内部app
export const isMyApp = apps.some(item => userAgent.includes(item));

// 判断是否是IphoneX
export function isIphoneX() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.screen.height >= 800 &&
    window.screen.width >= 375
  );
}
